/**
 * Profile scripts
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';

injector.injectClass(class extends Script {
    onLoad() {
        const $button = $('#unsubscribe');
        $button.on('click', () => {
            const vars = {
                e: $button.data('email'),
                s: $button.data('code'),
                unsubscribed: 1,
            };

            $.post('/amember/ajax/unsubscribed', vars).done(() => {
                location.reload();
            }).fail(() => {
                alert('Something went wrong!');
            });
        });
    }
}, ['unsubscribe']);
